<template>
  <div>
    <!-- <VueUeditorWrap /> -->
  </div>
</template>
<script>
// import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    // VueUeditorWrap
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>
